<template>
  <input
    type="time"
    class="time-input"
    :value="inputValue"
    :disabled="disabled"
    @change="onChange"
  />
</template>

<script>
/**
 * 時刻の入力欄
 *
 * ブラウザ標準の time 入力を使う。時と分を別々の候補から選ばせるより、
 * 打つのもタブで移るのも速く、勝手に候補が開くこともない。
 *
 * 標準の time 入力は「09:00」の形しか扱えないが、DBは「9:00」で持っているため、
 * 出し入れのときにこのコンポーネントの中だけで変換する。
 */
export default {
  model: {
    prop: 'value',
    event: 'change'
  },

  props: {
    // 「9:00」の形（DBの持ち方に合わせる）
    value: {
      type: String,
      default: ''
    },

    disabled: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    /**
     * 入力欄へ渡す値（ゼロ埋めする）
     */
    inputValue() {
      const [hour, minute] = (this.value || '').split(':')
      if (!hour || !minute) {
        return ''
      }

      return ('0' + hour).slice(-2) + ':' + ('0' + minute).slice(-2)
    }
  },

  methods: {
    /**
     * 入力された値をDBの形（時の先頭に0を付けない）に戻して返す
     */
    onChange(e) {
      const [hour, minute] = (e.target.value || '').split(':')
      this.$emit('change', hour && minute ? Number(hour) + ':' + minute : '')
    }
  }
}
</script>

<style scoped>
.time-input {
  width: 100%;
  height: 30px;
  /* 曜日の列は狭いので、左右の余白は詰める */
  padding: 0 2px;
  border: 1px solid #d1d5db;
  border-radius: 4px;
  background: #fff;
  color: #374151;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}

/* 時計のアイコンは列が狭いので出さない（クリックしなくても数字で打てる） */
.time-input::-webkit-calendar-picker-indicator {
  display: none;
}
</style>
